const SITE_URL = 'https://www.execora.se';
const SITE_NAME = 'Execora Consulting AB';

const PAGE_META = {
  home: {
    path: '/',
    swe: {
      title: 'Execora Consulting AB | Rekrytering, bemanning och interim',
      description:
        'Execora Consulting AB hjälper företag med rekrytering, bemanning och interim inom bland annat teknik, IT och ekonomi, med profiler som ingenjörer och andra specialister. Med bas i Jönköping och uppdrag i hela Sverige.'
    },
    eng: {
      title: 'Execora Consulting AB | Recruitment, staffing and interim',
      description:
        'Execora Consulting AB helps companies with recruitment, staffing and interim solutions within engineering, IT and finance. Based in Jönköping with assignments across Sweden.'
    }
  },
  about: {
    path: '/omoss',
    swe: {
      title: 'Om oss | Execora Consulting AB',
      description:
        'Lär känna Execora. Vi bygger långsiktiga relationer mellan företag och specialister inom IT, teknik och ekonomi, med bas i Jönköping.'
    },
    eng: {
      title: 'About us | Execora Consulting AB',
      description:
        'Get to know Execora. We build long-term relationships between companies and specialists within IT, engineering and finance, based in Jönköping.'
    }
  },
  contact: {
    path: '/kontakt',
    swe: {
      title: 'Kontakta oss | Execora Consulting AB',
      description:
        'Kontakta Execora Consulting AB i Jönköping. Berätta vad du behöver hjälp med inom rekrytering, bemanning eller interim så återkommer vi snabbt.'
    },
    eng: {
      title: 'Contact us | Execora Consulting AB',
      description:
        'Contact Execora Consulting AB in Jönköping. Tell us what you need within recruitment, staffing or interim and we will get back to you quickly.'
    }
  },
  competence: {
    path: '/kompetens',
    swe: {
      title: 'Hitta kompetens | Execora Consulting AB',
      description:
        'Hitta kompetens snabbare och mer träffsäkert. Vi tillsätter specialister inom IT, teknik, ingenjörskap och ekonomi med tydlig process och snabb leverans.'
    },
    eng: {
      title: 'Find competence | Execora Consulting AB',
      description:
        'Find the right competence faster. We place specialists within IT, engineering and finance with a clear process and fast delivery.'
    }
  },
  serviceRex: {
    path: '/rex',
    swe: {
      title: 'Rekrytering | Execora Consulting AB',
      description:
        'Rekrytering av specialister och ledande positioner inom teknik, IT och ekonomi. Tydlig kravbild, strukturerad urvalsprocess och rätt person för långsiktig tillväxt.'
    },
    eng: {
      title: 'Recruitment | Execora Consulting AB',
      description:
        'Recruitment of specialists and leadership roles within engineering, IT and finance. Clear requirements, structured selection and the right hire for lasting growth.'
    }
  },
  serviceBem: {
    path: '/bem',
    swe: {
      title: 'Bemanning | Execora Consulting AB',
      description:
        'Bemanning inom teknik, ingenjörskap, IT och ekonomi. Förstärkning med specialister som snabbt kommer in i arbetet när behovet uppstår.'
    },
    eng: {
      title: 'Staffing | Execora Consulting AB',
      description:
        'Staffing within engineering, IT and finance. Reinforce your team with specialists who get up to speed quickly when the need arises.'
    }
  },
  serviceInterim: {
    path: '/interim',
    swe: {
      title: 'Interim | Execora Consulting AB',
      description:
        'Interimlösningar med erfarna ledare och specialister som kliver in och skapar struktur direkt vid vakanser, transformationer eller tillväxt.'
    },
    eng: {
      title: 'Interim | Execora Consulting AB',
      description:
        'Interim solutions with experienced leaders and specialists who step in and create structure immediately during vacancies, transformations or growth.'
    }
  }
};

function setMeta(selector, attr, value) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

export function applyPageMeta(page, lang) {
  if (typeof document === 'undefined') return;

  const entry = PAGE_META[page] || PAGE_META.home;
  const copy = entry[lang] || entry.swe;
  const url = `${SITE_URL}${entry.path === '/' ? '/' : entry.path}`;

  document.title = copy.title;
  document.documentElement.lang = lang === 'eng' ? 'en' : 'sv';

  setMeta('meta[name="description"]', 'content', copy.description);
  setMeta('link[rel="canonical"]', 'href', url);

  setMeta('meta[property="og:url"]', 'content', url);
  setMeta('meta[property="og:title"]', 'content', copy.title);
  setMeta('meta[property="og:description"]', 'content', copy.description);
  setMeta('meta[property="og:site_name"]', 'content', SITE_NAME);
  setMeta('meta[property="og:locale"]', 'content', lang === 'eng' ? 'en_GB' : 'sv_SE');

  setMeta('meta[name="twitter:title"]', 'content', copy.title);
  setMeta('meta[name="twitter:description"]', 'content', copy.description);
}
